import React from 'react';
import { Link } from 'react-router-dom';

// import {OPTIONS} from './../../data/options';
import * as PORTFOLIOS from './../../data/portfolios';



export default class Component extends React.Component {

  render (){

    const OPTIONS = [
      PORTFOLIOS.vyiautvmuj74,
      PORTFOLIOS.caxkuxluhl7u,
      PORTFOLIOS.or7vdoj2r41k,
      PORTFOLIOS.em0t0dvw0q66,
      PORTFOLIOS.fa68b9b5201e,
      PORTFOLIOS.ed3h1vw1rx0p,
      // PORTFOLIOS.hv6ee7q8hc2x,
      PORTFOLIOS.jv0xy7kvihpv,
      PORTFOLIOS.ol6bd0nvnc78,
      PORTFOLIOS.x6slgsls1e2w,
      PORTFOLIOS.fx5ii76xk8v0,
      PORTFOLIOS.kq7duht3uqmd,
      PORTFOLIOS.enpcu80fscta,
    ];

    return (
      <section id="popular" className="content-section text-center py-5 my-5">
        
        <h2 className="text-center">Explore portfolios</h2>

        <p className="text-muted small my-3">
          These are sample portfolios from our current users. They get refreshed and updated frequently.
        </p>

        <div className="row">
          {OPTIONS.map(function(item, idx){
            return (
              <div key={"_"+idx} className="col-md-3">
                <Link to={"/portfolios/" + item.id} className="">
                <div className="card bg-primary my-3">
                  <div className="card-body">
                    <h5 className="card-title text-white">{item.title}</h5>
                    <div className="card-text">
                      <div className="small text-dark">
                        {item.stocks.length} stocks
                      </div>
                    <div className="pt-2 ">
                      {[...Array(item.popularity)].map((e, i) => <span className="" key={i}><i className="fas fa-star mx-2 text-dark"></i></span>)}
                    </div>
                    </div>
                  </div>
                </div>
                </Link>
              </div>
            )
          })}
        </div>
      </section>
    )
  }
}